import React from "react";
import { connect } from "react-redux";
import { Merge } from "../../models";
import { notification } from "../../services";
import { Compare } from "../../components/Merge";
import Header from "../../components/Merge/Header";
import { Progress, getURLParam } from "../../lib";
import { setWindowTitle } from "../../helpers";
import { Content, Container } from "../../pages/Template";
import { AppState } from "../../store";
import { RouteMatch } from "../../lib";
import { AxiosResponse } from "axios";

const mapState = (state: AppState, ownProps: OwnProps) => ({
    user: state.user,
    doc_id: parseInt(ownProps.match.params.doc_id),
});
export type ComparePage = {
    user_id: number;
    user_name: string;
    user_status: string;

    page_id: number;
    page_name: string;
    page_contents_id: number;
};
type StateProps = ReturnType<typeof mapState>;
type OwnProps = {
    match: RouteMatch;
};
type Props = StateProps & OwnProps;
type State = {
    pages: ComparePage[] | null;
    loaded: boolean;
    compare: {
        src: number;
        dst: number;
    };
};

class CreateMergePage extends React.Component<Props, State> {
    static paths = ["/app/merge/:doc_id/"];
    static requiresAuth = true;

    constructor(props: Props) {
        super(props);

        this.state = {
            pages: null,
            loaded: false,
            compare: {
                src: -1,
                dst: -1,
            },
        };

        this.onConfirm = this.onConfirm.bind(this);
    }

    componentDidMount() {
        this.fetch();
        setWindowTitle("کام ملاؤ");
    }

    async fetch() {
        this.setState({ loaded: false });

        const { doc_id } = this.props;
        const { data }: AxiosResponse<ComparePage[]> = await Merge.fetch(
            "pages",
            {
                doc_id,
            }
        );
        this.setState({ pages: data, loaded: true });
    }

    onCompare = (src: number, dst: number) =>
        this.setState({ compare: { src, dst } });
    onCompareClear = () => this.setState({ compare: { src: -1, dst: -1 } });

    onConfirm = async (page_id: number, src: number, dst: number) => {
        this.setState({
            loaded: false,
            compare: {
                src: -1,
                dst: -1,
            },
        });

        try {
            const { doc_id } = this.props.match.params;
            await Merge.create(
                {
                    page_id,
                    src_page_contents_id: src,
                    dst_page_contents_id: dst,
                },
                { doc_id }
            );
            this.setState({ loaded: true });
            notification.set("merge.requestCreated", "s");
        } catch (e) {
            console.warn("Merge request error", e);
        }
    };

    render() {
        if (!this.state.loaded || !this.state.pages) {
            return <Progress />;
        }

        const { user } = this.props;
        const { doc_id } = this.props.match.params;
        const { pages, compare } = this.state;

        let param_page_id = getURLParam("page_id");
        let page_contents_id = -1;
        if (!!param_page_id) {
            const page_id = parseInt(param_page_id);
            for (const p of pages) {
                if (
                    p &&
                    p.page_id === page_id &&
                    //@ts-ignore
                    p.user_id === user.get("id")
                ) {
                    page_contents_id = p.page_contents_id;
                    break;
                }
            }
        }

        return (
            <Content>
                <Container width="80%">
                    <Header
                        pages={pages}
                        page_contents_id={page_contents_id}
                        onCompare={this.onCompare}
                        onCompareClear={this.onCompareClear}
                        onConfirm={this.onConfirm}
                    />

                    {pages.length > 0 && (
                        <Compare doc_id={parseInt(doc_id)} compare={compare} />
                    )}
                </Container>
            </Content>
        );
    }
}

export default connect(mapState)(CreateMergePage);
